import React, { useEffect, useState } from "react";
import moment from "moment";
import { fetchJson } from "../../lib/Fetching";
import Select from "react-select";

export default function TestQueryParametersSelect({
  selectedId,
  defaultValue,
  company_id,
  handleSelectChange,
}) {
  const [options, setOptions] = useState([]);

  const fetchData = () =>
    fetchJson("/result_notifications/test_query_parameters.json").then((json) => {
      if (json.error) alert(json.error);
      else setOptions(json);
    });

  useEffect(
    () => {
      fetchData();
    },
    [company_id]
  );

  const displayOptions = options.map((b) => ({
    value: b.id,
    label: b.name,
  }));

  const selectedOptions = displayOptions.filter((o) => selectedId === o.value);

  return (
    <Select
      value={selectedOptions}
      isMulti={false}
      placeholder={"Chose Search Parameters..."}
      name="tqp"
      options={displayOptions}
      onChange={handleSelectChange}
      className="basic-multi-select"
      classNamePrefix="select"
    />
  );
}
